<script setup lang="ts">
withDefaults(
  defineProps<{
    isDot?: boolean;
    isHidden?: boolean;
    isPulsing?: boolean;
  }>(),
  {
    isDot: false,
    isHidden: false,
    isPulsing: true,
  }
);
</script>

<template>
  <span class="relative inline-flex shrink-0 align-middle">
    <span
      v-if="isPulsing && !isHidden"
      class="absolute inset-0 hidden rounded-full bg-amber-400 opacity-60 motion-safe:inline-flex motion-safe:animate-ping"
    ></span>

    <span
      :class="[
        'relative inline-flex rounded-full border font-bold',
        isHidden ? 'border-slate-300 bg-slate-100 text-slate-500' : 'border-amber-300 bg-amber-100 text-amber-800',
        isDot ? 'size-2.5' : 'px-1.5 text-[10px] leading-[14px]',
      ]"
    >
      <template v-if="!isDot">
        {{ $t(isHidden ? 'helpTips.pill.hidden' : 'helpTips.pill.new') }}
      </template>
    </span>
  </span>
</template>
